





import '@/assets/scss/pages/dashboard-ecommerce.scss';
import { Component, Prop } from 'vue-property-decorator';
import { BaseMixin } from '@/mixins/BaseMixin';
import { mixins } from 'vue-class-component';

@Component({
  components: {},
})
export default class AdmiralAvatar extends mixins(BaseMixin) {
  @Prop({ required: false, type: String, default: () => 'md' })
  size!: 'sm' | 'md' | 'md2' | 'lg' | 'xl';

  @Prop({ required: false, type: String })
  clazz!: string;

  get avatarSize() {
    return this.size || 'md';
  }
}
